<div class="toolbar" [matMenuTriggerFor]="profileActionsMenu">
  <mat-icon color="accent">perm_identity</mat-icon>
  <span class="user-name">{{auth.userProfile.value.fullName}}</span>
</div>
<mat-menu #profileActionsMenu="matMenu">
  <button mat-menu-item (click)="logOut()">{{'BUTTONS.LOG_OUT' | translate}}</button>
</mat-menu>

